
import * as defaultImport from "@splunk/visualization-encoding/Options";
export * from "@splunk/visualization-encoding/Options";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
